import api from './api';

const locationService = {
  // Get all locations (hierarchical — regions with nested children)
  getAllLocations: async (params = {}) => {
    const response = await api.get('/locations', { params });
    return response.data;
  },

  // Get all locations flat (for dropdowns)
  getAllLocationsFlat: async () => {
    const response = await api.get('/locations/flat');
    return response.data;
  },

  // Get location by ID
  getLocationById: async (id) => {
    const response = await api.get(`/locations/${id}`);
    return response.data;
  },

  // Create location (admin)
  createLocation: async (locationData) => {
    const response = await api.post('/locations', locationData);
    return response.data;
  },

  // Update location (admin)
  updateLocation: async (id, locationData) => {
    const response = await api.put(`/locations/${id}`, locationData);
    return response.data;
  },

  // Delete location (admin)
  deleteLocation: async (id) => {
    const response = await api.delete(`/locations/${id}`);
    return response.data;
  },
};

export default locationService;
